import { createAction } from "@reduxjs/toolkit";
import type { CreateTeacherStudioBody } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const createTeacherStudio = createApiThunk<string, CreateTeacherStudioBody>(
  "teacher/studio/create",
  async (body, { extra: { teacherRepository } }) => {
    return teacherRepository!.createStudio(body);
  },
);

export const resetCreateTeacherStudio = createAction("teacher/studio/resetCreate");
